module.exports = __webpack_public_path__ + "static/media/logo_transparent.fa028534.png";